import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-325e27c6"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("招商品种管理");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("查看招商品种");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑招商品种");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增招商品种");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_6 = {
  key: 0,
  style: {
    "margin-right": "10px"
  }
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("选择发起人");

const _hoisted_8 = {
  class: "tag-wrap"
};
const _hoisted_9 = {
  class: "contact-row"
};
const _hoisted_10 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_11 = {
  key: 0,
  style: {
    "color": "#909399"
  }
};
const _hoisted_12 = {
  key: 0,
  class: "area-recruit-panel"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "area-recruit-title"
}, "区域招满状态", -1));

const _hoisted_14 = {
  class: "area-recruit-name"
};
const _hoisted_15 = {
  class: "price-row"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "price-sep"
}, "~", -1));

const _hoisted_17 = /*#__PURE__*/_createTextVNode("保存");

import { computed, onMounted, reactive, ref } from 'vue';
import { saveAttractProduct, getAttractConfig, getAttractAreaList, getAttractProductDetail, getVarietyDetail } from '@/request';
import { ElMessage } from 'element-plus';
import AddVarietyModal from '@/components/AddVarietyModal.vue';
import SelectInitiatorModal from '@/views/RecruitHire/component/SelectInitiatorModal.vue';
import { useRoute, useRouter } from 'vue-router';
export default {
  name: 'SaveAttractInvestProduct',

  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    let form = ref({
      varietyId: null,
      goodsId: null,
      prodName: '',
      companyName: '',
      contactName: '',
      contactPhone: '',
      sponsorList: [],
      agencyType: 'national',
      advantageDesc: '',
      labelList: [],
      label: '',
      departmentList: [],
      saleChannelList: [],
      areaList: [],
      priceMin: null,
      priceMax: null,
      publishDate: '',
      deadline: ''
    });
    const agencyTypeOptions = [{
      label: '全国总代',
      value: 'national'
    }, {
      label: '省区代理',
      value: 'provincial'
    }, {
      label: '地市代理',
      value: 'city'
    }];
    const rawProvinceTree = ref([]);
    const areaRecruitMap = reactive({});
    /** 右侧招满面板：整省勾选展示省；仅勾市展示市 */

    const selectedAreas = ref([]);
    const areaTreeCheckedKeys = ref([]);
    const areaTreeKey = ref(0);
    /** 编辑回显：等区域树与详情都就绪后再勾树 */

    const pendingAreaInit = ref(null);
    const isEdit = ref(false);
    const isSee = ref(false);
    const isNationalAgency = computed(() => form.value.agencyType === 'national');
    onMounted(() => {
      if (route.query.id) {
        isSee.value = !!route.query.isSee;
        isEdit.value = !route.query.isSee;
        getAttractProductDetail({
          zsProdId: route.query.id,
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            var _data$data$priceMin, _data$data$priceMax;

            const recruitMap = {};
            (data.data.areaList || []).forEach(item => {
              var _item$recruitStatus;

              recruitMap[item.id] = (_item$recruitStatus = item.recruitStatus) !== null && _item$recruitStatus !== void 0 ? _item$recruitStatus : 0;
            });
            Object.keys(areaRecruitMap).forEach(key => delete areaRecruitMap[key]);
            Object.assign(areaRecruitMap, recruitMap);
            form.value = _objectSpread(_objectSpread(_objectSpread({}, form.value), data.data), {}, {
              sponsorList: data.data.sponsorList || [],
              agencyType: resolveAgencyType(data.data),
              departmentList: data.data.departmentList.map(i => i.id),
              saleChannelList: data.data.saleChannelList.map(i => i.id),
              areaList: data.data.areaList.map(i => i.id),
              priceMin: (_data$data$priceMin = data.data.priceMin) !== null && _data$data$priceMin !== void 0 ? _data$data$priceMin : null,
              priceMax: (_data$data$priceMax = data.data.priceMax) !== null && _data$data$priceMax !== void 0 ? _data$data$priceMax : null,
              varietyId: data.data.varietyId || null
            });
            pendingAreaInit.value = {
              areaItems: data.data.areaList || [],
              agencyType: form.value.agencyType
            };
            rebuildAreaTree();
            refreshAreaTreeAndPanel(pendingAreaInit.value.areaItems, pendingAreaInit.value.agencyType);
          }
        });
      }
    });
    const formRef = ref();
    const areaData = ref([]);
    const showAddVarietyModal = ref(false);
    const showInitiatorModal = ref(false);
    const defaultSelectedInitiators = computed(() => (form.value.sponsorList || []).map(item => ({
      supAccountId: item.id,
      linkMan: item.text,
      loginName: item.loginName || '',
      linkPhone: item.linkPhone || '',
      supplierName: item.supplierName || ''
    })));
    const treeRef = ref();
    const departmentsOption = ref([]);
    const channleOption = ref([]);
    const NATIONAL_AREA_CODE = '100000';
    const NATIONAL_AREA_TEXT = '全国';
    const sponsorListRules = [{
      validator: (_rule, _value, callback) => {
        var _form$value$sponsorLi;

        if (!((_form$value$sponsorLi = form.value.sponsorList) !== null && _form$value$sponsorLi !== void 0 && _form$value$sponsorLi.length)) {
          callback(new Error('请选择发起人'));
        } else {
          callback();
        }
      },
      trigger: 'change'
    }];

    function addVariety(variety) {
      form.value.varietyId = variety.varietyId;
      form.value.goodsId = variety.goodsId;
      form.value.prodName = variety.prodName;
      form.value.advantageDesc = '';
      form.value.labelList = [];
      getVarietyDetail({
        varietyId: variety.varietyId,
        __repeat: true,
        __warn: true
      }).then(res => {
        if (!res.success || !res.data) return;
        form.value.advantageDesc = res.data.advantageDesc || '';
        form.value.labelList = res.data.labelList || [];
      });
    }

    function onInitiatorSelected(rows) {
      var _formRef$value;

      form.value.sponsorList = (rows || []).map(row => ({
        id: String(row.supAccountId),
        text: row.linkMan || row.loginName || String(row.supAccountId),
        loginName: row.loginName,
        linkPhone: row.linkPhone,
        supplierName: row.supplierName
      }));
      (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validateField('sponsorList');
    }

    function resolveAgencyType(data) {
      if (data !== null && data !== void 0 && data.agencyType) return data.agencyType;
      if ((data === null || data === void 0 ? void 0 : data.isAllNation) === 0) return 'national';
      const areas = (data === null || data === void 0 ? void 0 : data.areaList) || [];

      if (areas.some(item => item.id && !isProvinceCode(item.id) && String(item.id) !== '0')) {
        return 'city';
      }

      return 'provincial';
    }

    function isProvinceCode(id) {
      const code = String(id);
      return code.endsWith('0000') && code !== NATIONAL_AREA_CODE && code !== '0';
    }

    function buildDisabledProvinceTree(provinces, agencyType) {
      return (provinces || []).map(province => {
        const cities = (province.children || []).map(city => _objectSpread(_objectSpread({}, city), {}, {
          disabled: agencyType !== 'city' || agencyType === 'national'
        }));
        return _objectSpread(_objectSpread({}, province), {}, {
          disabled: agencyType === 'city' || agencyType === 'national',
          children: cities
        });
      });
    }

    function rebuildAreaTree() {
      const agencyType = form.value.agencyType || 'national';
      const provinces = buildDisabledProvinceTree(rawProvinceTree.value, agencyType);

      if (agencyType === 'national') {
        areaData.value = [{
          id: 0,
          text: '全国',
          disabled: true,
          children: provinces.map(province => _objectSpread(_objectSpread({}, province), {}, {
            disabled: true,
            children: (province.children || []).map(city => _objectSpread(_objectSpread({}, city), {}, {
              disabled: true
            }))
          }))
        }];
        return;
      }

      areaData.value = [{
        id: 0,
        text: '全国',
        disabled: true,
        children: provinces
      }];
    }

    function onAgencyTypeChange() {
      rebuildAreaTree();

      if (form.value.agencyType === 'national') {
        applyNationalAreaSelection();
        return;
      }

      selectedAreas.value = [];
      Object.keys(areaRecruitMap).forEach(key => delete areaRecruitMap[key]);
      areaTreeCheckedKeys.value = [];
      areaTreeKey.value += 1;
    }

    function applyNationalAreaSelection() {
      selectedAreas.value = [{
        id: NATIONAL_AREA_CODE,
        text: NATIONAL_AREA_TEXT
      }];

      if (areaRecruitMap[NATIONAL_AREA_CODE] === undefined) {
        areaRecruitMap[NATIONAL_AREA_CODE] = 0;
      }

      areaTreeCheckedKeys.value = [0];
      areaTreeKey.value += 1;
    }

    function initSelectedAreasFromAreaItems(areaItems, agencyType) {
      if (!Array.isArray(areaItems) || !areaItems.length) {
        selectedAreas.value = [];
        return;
      }

      selectedAreas.value = areaItems.map(item => ({
        id: item.id,
        text: item.text
      }));
      areaItems.forEach(item => {
        if (areaRecruitMap[item.id] === undefined) {
          var _item$recruitStatus2;

          areaRecruitMap[item.id] = (_item$recruitStatus2 = item.recruitStatus) !== null && _item$recruitStatus2 !== void 0 ? _item$recruitStatus2 : 0;
        }
      });

      if (agencyType === 'national' && !areaItems.length) {
        applyNationalAreaSelection();
      }
    }

    function getAreaTreeCheckedKeys(areaItems, agencyType) {
      if (!Array.isArray(areaItems) || !areaItems.length) {
        return agencyType === 'national' ? [0] : [];
      }

      return agencyType === 'national' ? [0] : areaItems.map(item => item.id);
    }
    /** 详情 areaList + 区域树数据就绪后，同步右侧招满面板与树勾选 */


    function refreshAreaTreeAndPanel(areaItems, agencyType) {
      initSelectedAreasFromAreaItems(areaItems, agencyType);
      if (!areaData.value.length) return;
      areaTreeCheckedKeys.value = getAreaTreeCheckedKeys(areaItems, agencyType);
      areaTreeKey.value += 1;
    }

    function formatCheckedKeys(treeList, targetList = []) {
      let checkedKeys = treeRef.value.getCheckedNodes();
      let list = [...targetList];
      treeList.forEach(item => {
        if (checkedKeys.find(v => v.id === item.id || String(v.id) === String(item.id))) {
          var _areaRecruitMap$item$;

          list.push({
            id: item.id,
            text: item.text,
            recruitStatus: (_areaRecruitMap$item$ = areaRecruitMap[item.id]) !== null && _areaRecruitMap$item$ !== void 0 ? _areaRecruitMap$item$ : 0
          });
          return;
        }

        if (item.children && item.children.length) {
          list = list.concat(formatCheckedKeys(item.children));
        }
      });
      return list;
    }
    /** 同步右侧招满面板 */


    function syncSelectedAreas() {
      if (!treeRef.value) return;
      const agencyType = form.value.agencyType || 'national';

      if (agencyType === 'national') {
        applyNationalAreaSelection();
        return;
      }

      const checked = treeRef.value.getCheckedNodes(false, false);
      let areas = [];

      if (agencyType === 'provincial') {
        areas = checked.filter(n => isProvinceCode(n.id) && String(n.id) !== '0').map(n => ({
          id: n.id,
          text: n.text
        }));
      } else if (agencyType === 'city') {
        areas = checked.filter(n => !isProvinceCode(n.id) && String(n.id) !== '0').map(n => ({
          id: n.id,
          text: n.text
        }));
      }

      selectedAreas.value = areas;
      areas.forEach(p => {
        if (areaRecruitMap[p.id] === undefined) {
          areaRecruitMap[p.id] = 0;
        }
      });
    }

    function attachAreaRecruitStatus(areaList) {
      if (!Array.isArray(areaList)) return [];
      return areaList.map(item => {
        var _ref, _areaRecruitMap$item$2;

        return {
          id: item.id,
          text: item.text,
          recruitStatus: (_ref = (_areaRecruitMap$item$2 = areaRecruitMap[item.id]) !== null && _areaRecruitMap$item$2 !== void 0 ? _areaRecruitMap$item$2 : item.recruitStatus) !== null && _ref !== void 0 ? _ref : 0
        };
      });
    }

    const departmentsMap = new Map();
    const channleMap = new Map();

    function save() {
      var _form$value$labelList, _form$value$sponsorLi2;

      if (!form.value.varietyId) {
        ElMessage.error('请选择品种');
        return;
      }

      if (!form.value.advantageDesc) {
        ElMessage.error('所选品种未配置品种优势，请先在品种库维护');
        return;
      }

      if (!((_form$value$labelList = form.value.labelList) !== null && _form$value$labelList !== void 0 && _form$value$labelList.length)) {
        ElMessage.error('所选品种未配置招商标签，请先在品种库维护');
        return;
      }

      if (!((_form$value$sponsorLi2 = form.value.sponsorList) !== null && _form$value$sponsorLi2 !== void 0 && _form$value$sponsorLi2.length)) {
        ElMessage.error('请选择发起人');
        return;
      }

      if (form.value.priceMin != null && form.value.priceMax != null && Number(form.value.priceMin) > Number(form.value.priceMax)) {
        ElMessage.error('招商最低价不能大于最高价');
        return;
      }

      if (!form.value.publishDate) {
        ElMessage.error('请选择发布日期');
        return;
      }

      if (!form.value.deadline) {
        ElMessage.error('请选择截止日期');
        return;
      }

      if (form.value.publishDate > form.value.deadline) {
        ElMessage.error('发布日期不能晚于截止日期');
        return;
      }

      const agencyType = form.value.agencyType || 'national';

      if (agencyType === 'national') {
        form.value.areaList = attachAreaRecruitStatus([{
          id: NATIONAL_AREA_CODE,
          text: NATIONAL_AREA_TEXT
        }]);
      } else {
        if (!selectedAreas.value.length) {
          ElMessage.error('请选择招商区域');
          return;
        }

        form.value.areaList = attachAreaRecruitStatus(selectedAreas.value);
      }

      let params = {
        zsProdId: form.value.zsProdId,
        varietyId: form.value.varietyId,
        companyName: form.value.companyName,
        contactName: form.value.contactName,
        contactPhone: form.value.contactPhone,
        advantageDesc: form.value.advantageDesc,
        qualificationDesc: form.value.qualificationDesc,
        applyNum: form.value.applyNum,
        labelList: form.value.labelList,
        areaList: form.value.areaList,
        departmentList: form.value.departmentList.map(val => departmentsMap.get(val)),
        saleChannelList: form.value.saleChannelList.map(val => channleMap.get(val)),
        sponsorList: form.value.sponsorList || [],
        priceMin: form.value.priceMin,
        priceMax: form.value.priceMax,
        publishDate: form.value.publishDate,
        deadline: form.value.deadline,
        agencyType,
        isAllNation: agencyType === 'national' ? 0 : 1,
        __repeat: true,
        __warn: true
      };
      formRef.value.validate(e => {
        if (e) {
          saveAttractProduct(params).then(data => {
            if (data.success) {
              ElMessage.success('保存成功!');
              router.back();
            }
          });
        }
      });
    }

    getAttractConfig().then(data => {
      if (data.success) {
        departmentsOption.value = data.data.userDepartments;
        departmentsOption.value.forEach(depa => {
          departmentsMap.set(depa.id, depa);
        });
        channleOption.value = data.data.userChannels;
        channleOption.value.forEach(channle => {
          channleMap.set(channle.id, channle);
        });
      }
    });
    getAttractAreaList().then(data => {
      if (data.success) {
        rawProvinceTree.value = data.data || [];
        rebuildAreaTree();

        if (pendingAreaInit.value) {
          refreshAreaTreeAndPanel(pendingAreaInit.value.areaItems, pendingAreaInit.value.agencyType);
        } else if (form.value.agencyType === 'national') {
          applyNationalAreaSelection();
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), isSee.value ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 0
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })) : isEdit.value ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 1
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 2
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }))]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Back",
          type: "primary",
          link: "",
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).back())
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form, {
        model: _unref(form),
        ref_key: "formRef",
        ref: formRef,
        disabled: isSee.value,
        "label-position": "left",
        "label-width": "130px",
        class: "attract-invest-form"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "关联品种:",
          prop: "varietyId",
          rules: {
            required: true,
            message: '请选择品种'
          }
        }, {
          default: _withCtx(() => [_unref(form).varietyId ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(form).prodName) + "（ID: " + _toDisplayString(_unref(form).varietyId) + "） ", 1)) : _createCommentVNode("", true), !isSee.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = $event => showAddVarietyModal.value = true)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(form).varietyId ? '重新选择' : '选择品种'), 1)]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_alert, {
            type: "info",
            closable: false,
            style: {
              "margin-top": "8px"
            },
            title: "从品种库选择启用品种；同品种可发多条招商。宣传主图/详情图/视频在品种管理维护，保存时自动同步"
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招商企业:",
          prop: "companyName",
          rules: {
            required: true,
            message: '企业名称不可为空'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).companyName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).companyName = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "发起人:",
          prop: "sponsorList",
          required: "",
          rules: sponsorListRules
        }, {
          default: _withCtx(() => [!isSee.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[3] || (_cache[3] = $event => showInitiatorModal.value = true)
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).sponsorList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_tag, {
              class: "tag",
              key: item.id,
              closable: !isSee.value,
              onClose: $event => {
                var _formRef$value2;

                _unref(form).sponsorList.splice(index, 1);

                (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 ? void 0 : _formRef$value2.validateField('sponsorList');
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
              _: 2
            }, 1032, ["closable", "onClose"]);
          }), 128))])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招商联系方式:",
          required: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form_item, {
            prop: "contactName",
            rules: {
              required: true,
              message: '联系人姓名不可为空'
            },
            class: "contact-form-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).contactName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).contactName = $event),
              placeholder: "姓名",
              maxlength: "20",
              style: {
                "width": "200px",
                "margin-right": "12px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "contactPhone",
            rules: {
              required: true,
              message: '联系方式不可为空'
            },
            class: "contact-form-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).contactPhone,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).contactPhone = $event),
              placeholder: "联系方式",
              maxlength: "20",
              style: {
                "width": "240px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "品种优势简述:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "textarea",
            autosize: {
              minRows: 3
            },
            modelValue: _unref(form).advantageDesc,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).advantageDesc = $event),
            disabled: "",
            placeholder: "请先在品种库维护品种优势"
          }, null, 8, ["modelValue"]), _createVNode(_component_el_alert, {
            type: "info",
            closable: false,
            style: {
              "margin-top": "8px"
            },
            title: "品种优势与招商标签归属品种主数据，请到「品种库」维护；此处只读展示"
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招商标签:"
        }, {
          default: _withCtx(() => {
            var _unref$labelList;

            return [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).labelList, (item, index) => {
              return _openBlock(), _createBlock(_component_el_tag, {
                class: "tag",
                key: index
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                _: 2
              }, 1024);
            }), 128)), !((_unref$labelList = _unref(form).labelList) !== null && _unref$labelList !== void 0 && _unref$labelList.length) ? (_openBlock(), _createElementBlock("span", _hoisted_11, "暂无标签，请先在品种库维护")) : _createCommentVNode("", true)])];
          }),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "代理商类型:",
          prop: "agencyType",
          rules: {
            required: true,
            message: '请选择代理商类型'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: _unref(form).agencyType,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(form).agencyType = $event),
            disabled: isSee.value,
            onChange: onAgencyTypeChange
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(agencyTypeOptions, item => {
              return _createVNode(_component_el_radio, {
                key: item.value,
                label: item.value
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                _: 2
              }, 1032, ["label"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招商区域:",
          prop: "areaList",
          rules: {
            required: true,
            message: '招商区域不可为空'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
            class: _normalizeClass({
              'area-tree-readonly': _unref(isNationalAgency)
            }),
            style: {
              "border": "1px solid #ccc",
              "border-radius": "10px",
              "padding": "10px",
              "width": "400px"
            },
            height: "300px"
          }, {
            default: _withCtx(() => [areaData.value.length ? (_openBlock(), _createBlock(_component_el_tree, {
              ref_key: "treeRef",
              ref: treeRef,
              key: areaTreeKey.value,
              data: areaData.value,
              "show-checkbox": "",
              "node-key": "id",
              "check-strictly": _unref(form).agencyType !== 'national',
              "default-checked-keys": areaTreeCheckedKeys.value,
              props: {
                label: 'text',
                children: 'children',
                disabled: 'disabled'
              },
              onCheck: syncSelectedAreas
            }, null, 8, ["data", "check-strictly", "default-checked-keys"])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["class"]), selectedAreas.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_hoisted_13, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedAreas.value, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "area-recruit-row"
            }, [_createElementVNode("span", _hoisted_14, _toDisplayString(item.text), 1), _createVNode(_component_el_switch, {
              modelValue: areaRecruitMap[item.id],
              "onUpdate:modelValue": $event => areaRecruitMap[item.id] = $event,
              "active-value": 1,
              "inactive-value": 0,
              "active-text": "已招满",
              "inactive-text": "可报名",
              disabled: isSee.value
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]);
          }), 128))])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "适合科室:",
          prop: "departmentList",
          rules: {
            required: true,
            message: '科室不可为空'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            multiple: "",
            modelValue: _unref(form).departmentList,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(form).departmentList = $event),
            placeholder: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departmentsOption.value, depart => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: depart.text,
                key: depart.id,
                value: depart.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "销售渠道:",
          prop: "saleChannelList",
          rules: {
            required: true,
            message: '销售渠道不可为空'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            multiple: "",
            modelValue: _unref(form).saleChannelList,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).saleChannelList = $event),
            placeholder: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channleOption.value, channle => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: channle.text,
                key: channle.id,
                value: channle.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招商价格:"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_input_number, {
            modelValue: _unref(form).priceMin,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).priceMin = $event),
            precision: 2,
            min: 0,
            step: 0.01,
            placeholder: "最低价",
            "controls-position": "right"
          }, null, 8, ["modelValue", "step"]), _hoisted_16, _createVNode(_component_el_input_number, {
            modelValue: _unref(form).priceMax,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).priceMax = $event),
            precision: 2,
            min: 0,
            step: 0.01,
            placeholder: "最高价",
            "controls-position": "right"
          }, null, 8, ["modelValue", "step"])]), _createVNode(_component_el_alert, {
            type: "warning",
            title: "招商展示价，非商品实时售价，留空则小程序端不展示价格"
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "代理资格简述:",
          prop: "qualificationDesc",
          rules: {
            required: true,
            message: '代理资格简述不可为空'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "textarea",
            autosize: {
              minRows: 4
            },
            modelValue: _unref(form).qualificationDesc,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(form).qualificationDesc = $event),
            placeholder: "简要描述药企对代理商的相关要求/以及相关优惠政策等",
            maxlength: "300",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "初始申请人数:",
          prop: "applyNum",
          rules: {
            required: true,
            message: '初始申请人数不可为空'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: _unref(form).applyNum,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(form).applyNum = $event),
            "step-strictly": true,
            precision: 0,
            min: 0,
            max: 99999999,
            onBlur: _cache[14] || (_cache[14] = $event => _unref(form).applyNum = isNaN(Number(_unref(form).applyNum)) ? 0 : Number(_unref(form).applyNum))
          }, null, 8, ["modelValue"]), _createVNode(_component_el_alert, {
            type: "warning",
            title: "营造申请火热氛围，但是也请合理配置哦，避免数据水分过大影响品牌信任度"
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发布日期",
              prop: "publishDate",
              rules: {
                required: true,
                message: '请选择发布日期'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: _unref(form).publishDate,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(form).publishDate = $event),
                type: "date",
                "value-format": "YYYY-MM-DD",
                disabled: isSee.value
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "截止日期",
              prop: "deadline",
              rules: {
                required: true,
                message: '请选择截止日期'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: _unref(form).deadline,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(form).deadline = $event),
                type: "date",
                "value-format": "YYYY-MM-DD",
                disabled: isSee.value
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "disabled"]), _createVNode(_component_el_row, {
        type: "flex",
        justify: "center"
      }, {
        default: _withCtx(() => [!isSee.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(AddVarietyModal, {
        modelValue: showAddVarietyModal.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => showAddVarietyModal.value = $event),
        onSuccess: addVariety
      }, null, 8, ["modelValue"]), _createVNode(SelectInitiatorModal, {
        modelValue: showInitiatorModal.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => showInitiatorModal.value = $event),
        "default-selected": _unref(defaultSelectedInitiators),
        onSuccess: onInitiatorSelected
      }, null, 8, ["modelValue", "default-selected"])]);
    };
  }

};